export const ACTIONS_WALLET = {
	MY_WALLET_VIEW: 'wallet_view',
	MY_WALLET_CREATE: 'wallet_create',
	MY_WALLET_UPDATE: 'wallet_update',
} as const;
